const API_BASE_URL = process.env.REACT_APP_WEB_API;
const API_Payment_URL = process.env.REACT_APP_PAYMENT_API;

export const GetUsers = async ({SearchString, CurrentPage, RowsToReturn}) => {
    const url = `${API_Payment_URL}Account/GetUsers`;
    const data = {
      SearchString: SearchString,
      CurrentPage: CurrentPage,
      RowsToReturn: RowsToReturn,
    };
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        return errorDetails;
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Error", error);
    }
  };

  export const GetSectionsLookUps = async () => {
    const url = `${API_Payment_URL}Account/HubSectionsLookUp`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        return errorDetails;
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Error", error);
    }
  };


  export const SendResetEmailTemporaryPassword = async (username) => {
    
    const url = `${API_Payment_URL}Account/SendResetEmail`;
    const data = {
      Username: username
    };
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        return errorDetails;
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Error", error);
    }
  };
  export const UpdateUser = async (data) => {
  // data should be the flat payload your API expects:
  // {
  //   Id, Department, Position, Token, PhoneNumber, RequestLimit,
  //   PaymentRequestsAccessLevel, Ext, HubSection: [{Id, Choice}],
  //   PaymentRequestType: [{Type, Choice}],
  //   ProfilePic // optional (base64 data URL or existing path)
  // }
  const url = `${API_Payment_URL}Account/UpdateUser`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      // keep same error handling style as other APIs
      let errorDetails = null;
      try {
        errorDetails = await response.json();
      } catch (e) {
        errorDetails = { statusCode: response.status, message: await response.text() };
      }
      return errorDetails;
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error", error);
  }
};

export const CreateUser = async (data) => {
  // data should be the flat payload your API expects:
  // {
  //   UserName, Email, PasswordHashed,
  //   Department, Position, Token, PhoneNumber, Ext,
  //   RequestLimit, PaymentRequestsAccessLevel,
  //   HubSection: [{ Id }],                 // or [{ Id, Choice }] if your API supports Choice
  //   PaymentRequestType: [{ Type }],       // or [{ Type, Choice }]
  //   ProfilePic // optional (data URL base64)
  // }
  const url = `${API_Payment_URL}Account/CreateUser`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      // same error handling pattern as UpdateUser
      let errorDetails = null;
      try {
        errorDetails = await response.json();
      } catch (e) {
        errorDetails = { statusCode: response.status, message: await response.text() };
      }
      return errorDetails;
    }

    // Some APIs may return 204 No Content after create
    if (response.status === 204) return { success: true };

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error", error);
  }
};

